// @spec BCP-STR-038
// BCP Dashboard page

import { createFileRoute } from '@tanstack/react-router';

import { BCPDashboard } from '@/features/bcp/components/BCPDashboard';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.bcpDashboard'),
  }),
  component: BCPDashboardPage,
});

function BCPDashboardPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <BCPDashboard />
      </div>
    </div>
  );
}
